import { useState, useEffect } from "react";
import { getCustomers } from "../services/customers";

let cachedCustomers = null; // global in-memory cache

export const useCustomers = ({ reload = false, params = {} } = {}) => {
  const [customers, setCustomers] = useState(cachedCustomers || []);
  const [loading, setLoading] = useState(false);

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const [err, data] = await getCustomers(params);
      if (!err) {
        cachedCustomers = data.results || [];
        setCustomers(cachedCustomers);
      }
    } catch (e) {
      console.error("Error fetching customers:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cachedCustomers || reload) {
      fetchCustomers();
    } else {
      setCustomers(cachedCustomers);
    }
  }, [reload, JSON.stringify(params)]); // refetch if reload or params change

  return { customers, loading, refresh: fetchCustomers };
};
